import {initHeaderScrollShadow} from "../../js/util/HeaderUtils.js";

export default class HeaderHtml {
    #root;

    /** @param {HTMLElement} headerEl */
    show(headerEl) {
        this.#root = headerEl;
        this.#root.insertAdjacentHTML('beforeend', this.#template())
        initHeaderScrollShadow(headerEl);
    }

    /** @returns {HTMLElement} */
    getHeaderMenuElement(){
        return this.#root.querySelector('.header__menu')
    }

    #template(){
        return `
            <div class="header__container">
                <div class="header__logo-section">
                    <a class="header__logo" href="/">Meve</a> <p class="header__sublogo">tracks down molecules</p>
                </div>
                <div class="header__menu-section">
                    <a class="header__website-link" href="https://elsci.io/meve" target="_blank">About</a>
                    <span class="header__menu"></span>
                </div>
            </div>
        `
    }
}